/* eslint-disable react/jsx-indent-props */
/* eslint-disable react/jsx-indent */
import React from 'react';
import { Link } from 'react-router-dom';

function ProfessioneSanitaQuoteInfo({ setShowGreeniaAI, professioniSanitaQuote }) {
  return (
        <div className="w-75 ms-auto mb-3">
            <div className="bg-success border border-success p-3 rounded-3 shadow">
                <h5 className="fs-6 text-white">Nuovo Preventivo Professione Sanita</h5>
                <hr />
                <div>
                    <div>
                        <div className="row">
                            <div className="col-12">
                                <p className="m-0 text-white">
                                    <small>
                                        <strong>
                                            Professione:
                                        </strong>
                                        {' '}
                                        {professioniSanitaQuote?.quotes?.profession?.name}
                                    </small>
                                </p>
                            </div>
                        </div>
                        <hr />
                        {professioniSanitaQuote?.quotes?.quotes?.map((quote, index) => (
                            <div className="row" key={index}>
                                <div className="col-6">
                                    <p className="m-0 text-white">
                                        <small>
                                            <strong>
                                                Titolo:
                                            </strong>
                                            {' '}
                                            {quote?.name}
                                        </small>
                                    </p>
                                </div>
                                <div className="col-6">
                                    <p className="m-0 text-white">
                                        <small>
                                            <strong>
                                                Prezzo:
                                            </strong>
                                            {' '}
                                            {quote?.price}
                                            {' '}
                                            €
                                        </small>
                                    </p>
                                </div>
                                <div className="col-12">
                                    <p className="m-0 text-white">
                                        <small>
                                            <strong>
                                                Massimale:
                                            </strong>
                                            {' '}
                                            {quote?.massimale}
                                            {' '}
                                            €
                                        </small>
                                    </p>
                                </div>
                                <div className="col-12">
                                    <hr />
                                </div>
                            </div>
                        ))}

                        <div className="row mt-2">
                            <div className="col-12">
                                <Link
                                    onClick={() => setShowGreeniaAI(false)}
                                    className="btn btn-light"
                                    to={`/quote/rc-professionale-sanita/professioni-sanitarie/${professioniSanitaQuote?.fastQuoteId}`}
                                >
                                    Procedi con il Preventivo
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  );
}

export default ProfessioneSanitaQuoteInfo;
